import { Keyframe } from "./Keyframe";
export class StringKeyframe extends Keyframe {
    constructor() {
        super(...arguments);
        this.value = "";
    }
    cloneTo(destObject) {
        super.cloneTo(destObject);
        destObject.value = this.value;
    }
    clone() {
        let f = new StringKeyframe();
        this.cloneTo(f);
        return f;
    }
}
